module.exports = __webpack_public_path__ + "static/NkbmHome-3d1e91160fad12c62230537ca154f951.png";